import { LlmInitializationInputSchema } from "@redotech/redo-model/agents/llm-initialization-input";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getInitializationInputWithContext = {
  name: "getInitializationInputWithContext" as const,
  input: z.object({ _id: zExt.objectId() }),
  output: z.object({
    input: LlmInitializationInputSchema,
    firstAssistantResponse: z.string().optional(),
  }),
};
